import { SafeBaseObject } from "@app/core/models/base-object.models"
import { ResAdmVillaAmenities } from "@app/res-setup/models/resadm-property.models"
import { ResProduct } from "@app/reservation/models/res-package.model"
import { DateTime } from "luxon"

export interface IResVillaAvailabilityGetParams {
  VillaID:number
  Year?:number
  NightNum?:number
  GuestNum?:number
  Currency?:string
  PriceTypeID?:number
  BkgID?:number
}

export class ResVillaTree {
  id = 0
  tier = 0
  description = ''
  sortOrder = 0
  children:ResVillaTree[]=[]
  open = true
  get isLeaf() {
    return this.children.length=0
  }
  get isBranch() {
    return this.children.length>0
  }
  addData(_:any) {

  }
  clear() {
    this.children=[]
  }
}
export class ResVillaTreeAmenities extends ResVillaTree {
  description = 'Amenities'

  static tier(tier:number,a:ResAdmVillaAmenities) {
    const newTier = new ResVillaTreeAmenities()
    newTier.setTier(tier,a)
    return newTier
  }
  setTier(tier:number,a:ResAdmVillaAmenities) {
    const o:any = a
    this.id = o['villaAmenityID_'+tier] ?? 0
    this.description = o['villaAmenity_T'+tier] ?? ''
    this.tier = tier
    this.sortOrder = o['order_T'+tier] ?? 0
  }
  override addData(a:ResAdmVillaAmenities) {
    const o:any = a
    const tier = this.tier+1
    const id= o['villaAmenityID_'+tier] ?? 0
    if(id>0) {
      let branch = this.children.find(c=>c.id===id)
      if(!branch) {
        branch = ResVillaTreeAmenities.tier(tier,a)
        this.children.push(branch)
      }
      branch.addData(a)
    }

  }
}
export class ResVillaTreeOptions extends ResVillaTree {

  description = 'Options'

  static tier(tier:number,a:ResVillaOption) {
    const newTier = new ResVillaTreeOptions()
    newTier.setTier(tier,a)
    return newTier
  }
  getKeyTier(tier:number) {
    switch(tier) {
      case 1:
        return ['serviceTypeID','serviceTypeName']
      case 2:
        return ['serviceID','serviceName']
      case 3:
        return ['optionID','optionName']
      default:
        return ['','']
    }
  }
  setTier(tier:number,item:ResVillaOption) {
    const o:any = item
    const [keyId,keyDesc] = this.getKeyTier(tier)
    this.id = o[keyId] ?? 0
    this.description = o[keyDesc] ?? ''
    this.tier = tier
    this.sortOrder = tier
  }
  addData(item:ResVillaOption) {
    if(this.tier===3) return
    const o:any = item
    const tier = this.tier+1
    const [keyId,_] = this.getKeyTier(tier)
    const id = o[keyId] ?? 0
    if(id>0) {
      let branch = this.children.find(c=>c.id===id)
      if(!branch) {
        branch = ResVillaTreeOptions.tier(tier,o)
        this.children.push(branch)
      }
      branch.addData(o)
    }

  }
}

export class ResVillaSellingAvailability extends SafeBaseObject {
  product = new ResProduct()
  productAmenities:ResAdmVillaAmenities[] = []
  availability:ResVillaAvailabilityCalendar[] = []
  options:ResVillaOption[]=[]
  includedOptionsTree = new ResVillaTreeOptions()
  bailment = new ResVillaBailment()
  hasBailment = false
  amenitiesTree=new ResVillaTreeAmenities()
  hasExperience = false
  get includedOptions() {
    return this.options.filter(o=>o.included)
  }
  get excludedOptions() {
    return this.options.filter(o=>!o.included)
  }
  constructor(data?: any) {
    super();
    this.updateData(data);
  }

  override updateData(data?: any) {
    this.product = new ResProduct(data)
    if(data) {
      if(data.Amenities) this.productAmenities = data.Amenities.map((item:any)=>new ResAdmVillaAmenities(item))
      if(data.Availability) this.availability = data.Availability.map((item:any)=>{
        const dataAvailability = Object.assign({},item)
        dataAvailability.Prices = data.Prices ?? []
        return  new ResVillaAvailabilityCalendar(dataAvailability)
      })
      if(data.Options) this.options = data.Options.map((item:any)=>new ResVillaOption(item))
      if(data.Bailment) this.bailment = new ResVillaBailment(data.Bailment)
      this.hasBailment = this.bailment.preAuthPerc>0 || this.bailment.preAuthAmount >0
      this.amenitiesTree.clear()
      this.productAmenities.forEach(a=>this.amenitiesTree.addData(a))
      this.includedOptionsTree.clear()
      this.includedOptions.forEach(o=>this.includedOptionsTree.addData(o))
      this.hasExperience = !!this.options.find(o=>o.productCod==='EXP')
    }
  }
}

export class ResVillaOption extends SafeBaseObject {
  propertyOptionID = 0
  productCod = ''
  propertyID = 0
  serviceTypeID = 0
  serviceTypeName = ''
  supplierID = 0
  supplierName = ''
  serviceID = 0
  serviceName = ''
  optionID = 0
  optionName = ''
  priceSetupID = 0
  priceSetup = ''
  displaySequence = 0
  startDate = DateTime.invalid('empty')
  endDate = DateTime.invalid('empty')
  hideInBkg = false
  quantity = 0
  included = false
  cost = 0
  costCurrency = ''
  priceUSD = 0
  priceGBP = 0
  priceAUD = 0
  priceEUR = 0
  priceCAD = 0
  status = ''

  constructor(data?: any) {
    super();
    this.updateData(data);
  }

  override updateData(data?: any) {
    if(data) {
      super.updateData(data)
    }
  }
}

export class ResVillaBailment extends SafeBaseObject {
  preAuthPropertyID = 0
  propertyName = ''
  preAuthPerc	= 0
  preAuthAmount	= 0
  preAuthCurrency = ''
  endDate = DateTime.invalid('empty')

  constructor(data?: any) {
    super();
    this.updateData(data);
  }

  override updateData(data?: any) {
    if(data) {
      super.updateData(data)
    }
  }
}
export class ResVillaAvailabilityCalendar extends SafeBaseObject {
  date = DateTime.invalid('empty')
  villaStatusDesc = ''
  bkgID = 0
  bkgStatus = ''
  prices:ResVillaPriceCalendar[] = []
  status = ''
  originalStatus = ''
  description = ''
  fromPrice = ''
  statusDescription = ''
  tooltip = ''

  constructor(data?: any) {
    super();
    this.updateData(data);
  }
  private dateStringNormalized(s: string) {
    //trasform string in iso datetime
    return s;
  }
  override updateData(data?: any) {
    super.updateData(data)
    const today = DateTime.now().startOf('day').toMillis()
    if(data) {
      if(data.Prices) this.prices = data.Prices
                                        .filter((item:any)=>{
                                          const start = item.TravelStartDate ? DateTime.fromISO(this.dateStringNormalized(item.TravelStartDate)).startOf('day') : DateTime.invalid('empty');
                                          const end = item.TravelEndDate ? DateTime.fromISO(this.dateStringNormalized(item.TravelEndDate)).startOf('day') : DateTime.invalid('empty');
                                          if (!start.isValid || this.date.toMillis() < start.toMillis()) return false
                                          if (!end.isValid || this.date.toMillis() > end.toMillis()) return false
                                          return true
                                        })
                                        .map((item:any)=>item = new ResVillaPriceCalendar(item))
    }
    if(this.bkgID>0) this.status = this.bkgStatus
    if(this.status==='') this.status = this.villaStatusDesc
    switch(this.status) {
      case 'Available':
        this.statusDescription = ''
        break;
      case 'Not Available':
        if(this.date.toMillis()<=today) {
          this.status='Expired'
          this.statusDescription = '✖'
        } else {
          this.statusDescription = '🖈'
        }
        break;
      case 'Booked':
      case 'Option':
        this.statusDescription = '🖈'
        break;
    }
    if(this.description==='') this.description = this.villaStatusDesc
    this.originalStatus = this.status
  }
}
export class ResVillaPriceCalendar extends SafeBaseObject {
  villaPriceID = 0
  villaID = 0
  nightFrom	= 0
  nightTo	= 0
  sellingPrice = 0
  currency = ''
  priceTypeID	= 0
  travelStartDate = DateTime.invalid('empty')
  travelEndDate = DateTime.invalid('empty')
  paxFrom	= 0
  paxTo	= 0
  cost= 0
  costCurrency = ''
  note = ''
  invoiceTax = 0
  localTax = 0
  get isValid() {
    return this.villaPriceID>0
  }

  constructor(data?: any) {
    super();
    this.updateData(data);
  }

  override updateData(data?: any) {
    super.updateData(data)
  }

}

